var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { Entity } from '@square/dashboard-protos/models/squareup/sub2/data';
import { assert } from '@ember/debug';
import Sub2Client from '@square/dashboard-data/clients/sub2';
export let GroupToken = /*#__PURE__*/function (GroupToken) {
  GroupToken["STAFF_GROUP"] = "staff-group-v2";
  GroupToken["STAFF_GROUP_PER_LOCATION"] = "staff-group-v2-per-location";
  return GroupToken;
}({});
export let PlanToken = /*#__PURE__*/function (PlanToken) {
  PlanToken["STAFF_FREE"] = "staff-free";
  PlanToken["STAFF_FREE_PER_LOCATION"] = "staff-free-per-location";
  PlanToken["STAFF_PLUS"] = "staff-plus-v2";
  PlanToken["STAFF_PLUS_PER_LOCATION"] = "staff-plus-v2-per-location";
  PlanToken["STAFF_PREMIUM"] = "staff-premium-v2";
  PlanToken["STAFF_PREMIUM_PER_LOCATION"] = "staff-premium-v2-per-location";
  PlanToken["STAFF_ALLINONE"] = "staff-allinone";
  PlanToken["STAFF_ALLINONE_PER_LOCATION"] = "staff-allinone-per-location";
  PlanToken["PAYROLL_FOR_CONTRACTORS"] = "payroll_for_contractors";
  PlanToken["PAYROLL_FOR_EMPLOYEES"] = "payroll_for_employees";
  PlanToken["ADVANCED_ACCESS_PER_LOCATION"] = "advanced-access-per-location";
  PlanToken["HR_MANAGER"] = "hr-manager-monthly";
  return PlanToken;
}({});
let StaffSubscriptions = (_class = class StaffSubscriptions extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "modal", _descriptor2, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor3, this);
    _initializerDefineProperty(this, "i18n", _descriptor4, this);
    _initializerDefineProperty(this, "userSubscriptions", _descriptor5, this);
    _initializerDefineProperty(this, "staffPackagesPricingInfo", _descriptor6, this);
    _defineProperty(this, "subscriptions", {});
    _defineProperty(this, "currentSubscriptionPlan", void 0);
  }
  getPlanName(planToken) {
    switch (planToken) {
      case PlanToken.STAFF_FREE:
      case PlanToken.STAFF_FREE_PER_LOCATION:
        return this.i18n.t('employees.staff.packages.toasts.staff.free');
      case PlanToken.STAFF_PLUS:
      case PlanToken.STAFF_PLUS_PER_LOCATION:
        return this.i18n.t('employees.staff.packages.toasts.staff.plus');
      case PlanToken.STAFF_PREMIUM:
      case PlanToken.STAFF_PREMIUM_PER_LOCATION:
        return this.i18n.t('employees.staff.packages.toasts.staff.premium');
      case PlanToken.STAFF_ALLINONE:
      case PlanToken.STAFF_ALLINONE_PER_LOCATION:
        return this.i18n.t('employees.staff.packages.toasts.staff.allinone');
      case PlanToken.PAYROLL_FOR_CONTRACTORS:
      case PlanToken.PAYROLL_FOR_EMPLOYEES:
        return this.i18n.t('employees.staff.packages.toasts.staff.payroll');
      case PlanToken.ADVANCED_ACCESS_PER_LOCATION:
        return this.i18n.t('employees.staff.packages.toasts.staff.advanced.access');
      case PlanToken.HR_MANAGER:
        return this.i18n.t('employees.staff.packages.toasts.staff.hr.manager');
      default:
        return assert('default case should never reach');
    }
  }
  async loadPricingInfo(planToken) {
    if (this.staffPackagesPricingInfo[planToken] === undefined) {
      const planInfo = await Sub2Client.externalGetPricingInfo({
        planToken
      });

      // trigger update
      this.staffPackagesPricingInfo = {
        ...this.staffPackagesPricingInfo,
        [planToken]: planInfo
      };
    }
  }
  async loadSubscriptions() {
    const loadingSubscriptions = Object.values(PlanToken).map(value => this.tryGetSubscription(value).then(subscription => {
      this.subscriptions[value] = subscription;
      if (this.subscriptions[value]?.planGroupToken === GroupToken.STAFF_GROUP || this.subscriptions[value]?.planGroupToken === GroupToken.STAFF_GROUP_PER_LOCATION) {
        this.currentSubscriptionPlan = this.subscriptions[value];
      }
    }));
    await Promise.all(loadingSubscriptions);
  }
  async tryGetSubscription(planToken) {
    const subscriber = Entity.create({
      tokenType: Entity.TokenType.MERCHANT,
      token: this.userInfo.merchantToken
    });
    try {
      const {
        subscription
      } = await Sub2Client.externalGetSubscription({
        subscriptionKey: {
          subscriber,
          planToken
        }
      });
      return subscription;
    } catch (e) {
      // This endpoint returns a 404 response if the merchant does not have this type of subscription
      if (e.responseStatus === 404) {
        return undefined;
      } else {
        throw e;
      }
    }
  }
  async openSingleCheckoutModal({
    planToken,
    locationPlanToken
  }) {
    if (!this.currentSubscriptionPlan) {
      await this.loadSubscriptions();
    }
    const token = this.currentSubscriptionPlan?.planGroupToken === GroupToken.STAFF_GROUP ? planToken : locationPlanToken;
    const successMessage = this.i18n.t('employees.staff.packages.toasts.success', {
      planName: this.getPlanName(token)
    });
    const {
      didSubscribe,
      features
    } = await this.modal.open('subscriptions/sub2-activation-modal', {
      planToken: token,
      subscriptionToken: this.currentSubscriptionPlan?.token
    });
    if (didSubscribe) {
      const featureStatuses = features?.featureStatuses;

      // update subscribed features to correctly reflect subscriptions status
      if (featureStatuses) {
        await this.userSubscriptions.updateSubscriptionFeatures(featureStatuses);
      }
      this.marketToasts.success(successMessage);
    }
    return {
      didSubscribe: Boolean(didSubscribe)
    };
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "userSubscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "staffPackagesPricingInfo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
})), _class);
export { StaffSubscriptions as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.